/* eslint-disable react/no-array-index-key */

import React, {PureComponent} from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
import ChatBubble from './ChatBubble';
import ChatField from './ChatField';
import {Row, Col, Button} from 'reactstrap';
import Modal from "../../../components/Modal";
import FontAwesome from 'react-fontawesome';
import * as http from "../../../modules/http";
import {customers_delete} from "../../../redux/actions/CustomersActions";
//import { CurrentUserProps, ContactsProps } from '../../../shared/prop-types/ChatProps';

export default class Chat extends PureComponent {
    state = {
        chat: this.props.chat
    };

    clearChatHandle = () => {

        http.postToServer(
            'customers/clear_chat',
            {id: parseInt(this.props.userId)},
            (response) => {
                this.props.dispatch(this.setState({chat: []}));

            },
            (response) => {
                console.log('error delete creative');
            }
        );

    };

    deleteMessage = (index) => {
        let tmp = this.state.chat.slice();
        tmp.splice(index, 1);

        this.setState({chat: tmp});

        this.props.deleteMessage(index);
    };


    render() {

        const {currentUser, chat} = this.props;
        const chatClass = classNames({
            chat: true
        });

        return (
            <div className={chatClass}>
                <div className="chat__dialog">
                    <Scrollbar className="scroll chat__scroll" alwaysShowTracks style={{backgroundColor: 'lightgrey'}}>
                        <div className="chat__dialog-messages-wrap">
                            {this.state.chat === null || this.state.chat.length === 0 ?
                                <div className="chat__dialog-messages">
                                    <div className="chat__dialog-messages-empty">
                                        <p>אין הערות</p>
                                    </div>
                                </div>
                                :
                                <div className="chat__dialog-messages">
                                    {this.state.chat.map((m, i) =>
                                        (<ChatBubble
                                            key={i}
                                            name={m}
                                            message={m}
                                            date={m}
                                            mesId={i}
                                            isDelete={this.props.currentUser.isAdmin}
                                            active={(m.isStore !== undefined && m.isStore === 0)} //{m.name === this.props.currentUser.name}
                                            deleteMessage={this.deleteMessage}
                                        />))}
                                </div>
                            }
                        </div>
                    </Scrollbar>
                    {this.props.currentUser.isAdmin &&
                    <Row>
                        <Col md={11}>
                            <ChatField
                                comment={this.props.comment}
                                updateComment={this.props.updateComment}
                            />
                        </Col>
                        <Col md={1}>
                            <Modal color='danger' title='Are you sure!'
                                   approve={() => this.clearChatHandle()}
                                   message={'Delete Chat ?'}>
                                <i className="fa fa-trash-o" aria-hidden="true"
                                   style={{fontSize: '20px', marginTop: '10px', cursor: 'pointer'}}></i>
                            </Modal>
                        </Col>
                    </Row>}
                    {!this.props.currentUser.isAdmin &&
                    <ChatField
                        comment={this.props.comment}
                        updateComment={this.props.updateComment}
                    />}
                </div>
            </div>
        );
    }
}
